import moment from 'moment';

export const PERMISOS_FECHA_HORA_TURNO = ['TICKETS_MODIFICAR_TALLER', 'TICKETS_MODIFICAR_PRESUPUESTADOS'];

export const mostrarFechaHoraTurnoAlta = (getConfig, hasPermission) =>
    getConfig('mantenimientos.correctivo.fechaTurno.habilitado') === 'true'
    && getConfig('tickets.motivoAsignacion.habilitado') !== 'true'
    && getConfig('mantenimientos.correctivo.gerenciadores.habilitado') === 'true'
    && PERMISOS_FECHA_HORA_TURNO.some((permiso) => hasPermission(permiso));

export const formatearFechaHoraTurno = (fechaHoraTurno) =>
    fechaHoraTurno ? moment(fechaHoraTurno).format('YYYY/MM/DD HH:mm') : null;
